// extracted by mini-css-extract-plugin
export var numpadContainer = "_nv-1";
export var phoneButton = "_nv-0";